

import { useState } from "react";
import React from 'react'
import { Link } from "react-router-dom";

export default function InstallationService({ data, extraClass = "", }) {

  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <div className={`install-service ${extraClass}`}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 col-lg-6">
              <div className="image-wrapper">
                  <img src={data.image} alt="FAQ Image" className="img-responsive" />
              </div>
            </div>
            <div className="col-md-6 col-lg-6">
              <div className="heading-content">
                <h3 className="heading" dangerouslySetInnerHTML={{ __html: data?.heading }} />
              </div>
              <div className="install-col">
                <div className="install-faq">
                  {data.faqs.map((faq, index) => (
                    <div className={`item ${activeIndex === index ? "active-items" : ""}`} key={index} >
                      <div className={`faq-title ${activeIndex === index ? "active" : ""}`} onClick={() => toggleFaq(index)}   >
                        <div className="number-text"><span>{faq.number} </span></div>
                        <div className="faq-inner">  {faq.question}    </div>
                      </div>
                      <div className="faq-content" style={{ display: activeIndex === index ? "block" : "none" }}  >
                        <div className="content">
                          {typeof faq.answer === "string" ? (   <p>{faq.answer}</p>  ) : (    faq.answer     )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}




